import { useNavigation } from "@react-navigation/native"
import { useCallback, useState } from "react"
import { useSelector } from "react-redux"
import { getMostRecentActivity } from "../../data/utility/dataUtils"
import { useCurrentActivity } from "./useCurrentActivity"
import useLaunchActivity from "./useLaunchActivity"

const selectNextTodoActivity = (params) => {
    const {
        activityId,
        todoActivities,
        setIsLoading,
        navigation,
        setCurrentActivity,
        launchActivity,
    } = params

    const updatedTodoActivities = todoActivities
        .filter((activity) => activity.id !== Number(activityId))
        .filter((activity) => !activity.isDeleted)

    if (!updatedTodoActivities || updatedTodoActivities.length === 0) {
        setCurrentActivity({
            activityData: null,
            progressStatus: "none",
        })

        return false
    }

    const nextActivity = getMostRecentActivity(updatedTodoActivities, null)

    if (!nextActivity) {
        setCurrentActivity({
            activityData: null,
            progressStatus: "none",
        })

        return false
    }

    setIsLoading(false)
    launchActivity(nextActivity)

    return true
}

export const useNextTodoActivity = () => {
    const [isLoading, setIsLoading] = useState(false)
    const navigation = useNavigation()

    const schoolSubjects = useSelector((state) => state.data.schoolSubjects)
    const user = useSelector((state) => state.data.currentUser?.object)
    const isLiveMode = useSelector((state) => state.liveMode.isLiveModeEnabled)
    const liveSessionId = useSelector((state) => state.liveMode?.liveSessionId)
    const { setCurrentActivity } = useCurrentActivity()
    const launchActivity = useLaunchActivity()

    const selectNextActivity = useCallback(
        (todoActivities, activityId) => {
            return selectNextTodoActivity({
                todoActivities,
                activityId,
                schoolSubjects,
                studentId: user?.id,
                setIsLoading,
                navigation,
                setCurrentActivity,
                launchActivity,
            })
        },
        [
            schoolSubjects,
            user,
            isLiveMode,
            liveSessionId,
            navigation,
            setCurrentActivity,
            launchActivity,
        ]
    )

    return {
        selectNextActivity,
        isLoading,
    }
}

export default useNextTodoActivity
